//
//
//
//
//
//
//
//
//
//
//
export default (function (x) {
  return x["default"] || x;
})( // TODO: this should be analyzed after to find a better way to do this
// eslint-disable-next-line global-require -- old style
require('../components-implementation/info-window'));